export default __webpack_public_path__ + "static/DSC_0025-fdcd660441494d76e93a779bb6497ebb.jpg";